import { render, staticRenderFns } from "./FugaProducts.vue?vue&type=template&id=7ff01a31&"
import script from "./FugaProducts.vue?vue&type=script&lang=js&"
export * from "./FugaProducts.vue?vue&type=script&lang=js&"
import style0 from "./FugaProducts.vue?vue&type=style&index=0&id=7ff01a31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports